import { render, staticRenderFns } from "./san.vue?vue&type=template&id=69545d3f&scoped=true&"
import script from "./san.vue?vue&type=script&lang=js&"
export * from "./san.vue?vue&type=script&lang=js&"
import style0 from "./san.vue?vue&type=style&index=0&id=69545d3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69545d3f",
  null
  
)

export default component.exports